import { api } from './api';
import { publicApi } from './publicApi';

export let baseUrl = '/v1';

export const setBaseUrl = (url: string) => {
    baseUrl = url;
    publicApi?.setBaseURL(url);
    api?.setBaseURL(url);
};

export const getBaseUrl = () => {
    return baseUrl;
};

export const setDeviceInfo = (data: {
    device: string;
    ip: string;
    os: string;
    appVersion: string;
}) => {
    api?.setDeviceInfo?.({
        device: data.device,
        ip: data.ip,
        os: data.os,
        appVersion: data.appVersion,
    });
    publicApi?.setDeviceInfo?.({
        device: data.device,
        ip: data.ip,
        os: data.os,
        appVersion: data.appVersion,
    });
};

export const setKioskInfoForApi = (lockerId: number) => {
    api.setKioskInfo({
        lockerId,
    });
};
